import i18n from "i18next";
import resourcesToBackend from "i18next-resources-to-backend";
import { initReactI18next } from "react-i18next";

// Překlady vznikají z .resx backendu (scripts/gen-locales.mjs, R-16). Každý jazyk je samostatný
// soubor s hashem v názvu, který se načte až při přepnutí jazyka.
const locales = import.meta.glob<{ default: Record<string, string> }>("./locales/*.json");

export const languages = ["cs", "vi"] as const;
export type Language = (typeof languages)[number];
export const defaultLanguage: Language = "cs";

// Jazyk určuje users.language (RequireAuth po přihlášení); do prohlížeče se nic neukládá. Před přihlášením
// podle jazyka prohlížeče.
function browserLanguage(): Language {
  const preferred = navigator.languages.map((l) => l.slice(0, 2));
  return languages.find((l) => preferred.includes(l)) ?? defaultLanguage;
}

export async function changeLanguage(language: Language) {
  await i18n.changeLanguage(language);
}

// Úklid: dřívější verze ukládaly jazyk a přeskočené kroky START do localStorage.
try {
  for (const key of Object.keys(localStorage)) if (key.startsWith("gastroerp.")) localStorage.removeItem(key);
} catch {
  // Bez přístupu k úložišti není co uklízet.
}

i18n.on("languageChanged", (language) => document.documentElement.setAttribute("lang", language));

export const i18nReady = i18n
  .use(
    resourcesToBackend(async (language: string) => {
      const load = locales[`./locales/${language}.json`];
      if (!load) throw new Error(`Chybí překlad pro jazyk ${language}`);
      return (await load()).default;
    }),
  )
  .use(initReactI18next)
  .init({
    lng: browserLanguage(),
    fallbackLng: defaultLanguage,
    supportedLngs: languages,
    // Klíče jsou ploché názvy z .resx (např. "nav.tasks"), tečka neznamená vnoření.
    keySeparator: false,
    nsSeparator: false,
    interpolation: { escapeValue: false },
    returnNull: false,
  });

export default i18n;
